import React from "react";
import PageHero from "@/components/PageHero";
import LeadForm from "@/components/LeadForm";
import { Handshake, Globe2, TrendingUp, Lock } from "lucide-react";
import { useT } from "@/lib/i18n";

export default function Partner() {
  const { t } = useT();
  const BENEFITS = [
    { icon: Handshake, t: t("page.partner.b1.t"), d: t("page.partner.b1.d") },
    { icon: Globe2, t: t("page.partner.b2.t"), d: t("page.partner.b2.d") },
    { icon: TrendingUp, t: t("page.partner.b3.t"), d: t("page.partner.b3.d") },
    { icon: Lock, t: t("page.partner.b4.t"), d: t("page.partner.b4.d") },
  ];
  return (
    <div data-testid="page-partner">
      <PageHero
        eyebrow={t("nav.partner")}
        title={
          <>
            {t("page.partner.title.a")}{" "}
            <span className="text-[color:var(--zp-text-3)]">{t("page.partner.title.b")}</span>
          </>
        }
        subtitle={t("page.partner.sub")}
      />

      <section className="relative pb-12">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 grid grid-cols-1 md:grid-cols-2 gap-5">
          {BENEFITS.map((b, i) => (
            <div key={i} data-testid={`partner-benefit-${i}`} className="zp-card p-7">
              <div className="w-11 h-11 rounded-xl bg-[color:var(--zp-bg-2)] grid place-items-center text-[color:var(--zp-cyan-3)]">
                <b.icon size={18} strokeWidth={1.7} />
              </div>
              <h3 className="font-display text-xl tracking-tight mt-5">{b.t}</h3>
              <p className="text-[color:var(--zp-text-2)] mt-2 text-sm leading-relaxed">{b.d}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="relative pb-24">
        <div className="max-w-5xl mx-auto px-6 sm:px-8">
          <LeadForm source="partner" title={t("page.partner.formTitle")} />
        </div>
      </section>
    </div>
  );
}
